export const facturacion = {
    text1: "Mode de paiement",
    text2: "Carte de crédit",
    text3: "Aucun mode de paiement enregistré",
    text4: "Modifiez votre mode de paiement",
    text5: "Ajouter un mode de paiement",
    text6: "Ajouter un mode de paiement",
    text7: "Mettre à jour un mode de paiement",
    text8: "Enregistrez ou mettez à jour le mode de paiement sur lequel les prélèvements mensuels seront effectués.",
    text9: "Numéro de carte :",
    text10: "Exp",
    text11: "CVC",
    text12: "Enregistrer la carte",
    text13: "Numéro invalide",
    text14: "Invalide",
    text15: "CVC invalide.",
    text16: "Une erreur s'est produite",
    text17: "Consommation",
    text18: "Factures émises",
    text19: "Du - Au",
    text20: "ID",
    text21: "Montant",
    text22: "Entité émettrice de la facture",
    text23: "BIG NERDS COMPANY L.L.C.",
    text24: "Date d'émission",
    text25: "Statut",
    text26: "Télécharger la facture",
    text27: "Génération de la facture ...",
    text28: "Presque terminé, veuillez patienter...",
    text29: "Chargement ...",
    text30: "Désolé, la facture n'a pas pu être générée",
    text31: "Êtes-vous sûr de vouloir supprimer le mode de paiement ?",
    text32: "Vous perdrez vos données enregistrées",
    text33: "Supprimer le mode",
    text34: "Annuler",

    // Corrections
    p1: "Abonnement",
    p2: "Votre abonnement",
    p3: "FREE",
    p4: "CUSTOM",
    p5: "Vous n'avez pas d'abonnement actif. Remédions à cela !",
    p6: "Expire le :",
    p7: "Choisir un forfait",
    p8: "Mettre à niveau",
    p9: "Nombre de propriétés",
    p10: "Par propriété",
    p11: "Gérer l'abonnement",
    p12: "Paramètres de paiement",
    p13: "Expire le :",
    p14: "Modifier",
    p15: "Renouvellement automatique",
    p16: "Activé",
    p17: "Le prochain paiement est prévu le",
    p18: "Factures et reçus",
    p19: "CUSTOM",
    p20: "Voir la facture",
    p21: "Télécharger la facture",
    p22: "pour",

    p23: "Mensuel",
    p24: "Annuel",
    p25: "Nous vous offrons 2 mois en cadeau.",
    p26: "Type d'abonnement",


    p27: "Appartement touristique",
    p28: "Hôtel - Auberge",
    p29: "Camping",
    p30: "Villa",


    p31: `La « <strong>Propriété</strong> » repose sur des maisons ou des appartements individuels. Pour un « <strong>Aparthôtel</strong> », chaque appartement compte comme une seule propriété`,
    p32: `Cela compte comme des
    <strong>Chambres</strong> pour les hôtels, comme des lits pour les auberges,
    et comme des <strong>personnes </strong> pour les campings.

    <br />
    <strong>Par exemple :</strong> Une auberge de 4 chambres et 20 lits comptera comme
    20 unités d'hébergement`,

    p33: `PREMIUM`,
    p34: `mois`,
    p35: `chambre`,
    p36: `appartement`,
    p37: `Détails du forfait`,
    p38: `Check-in sur place via QR`,
    p39: `Check-in par lien envoyé au préalable`,
    p40: `Message d'e-mail de bienvenue`,
    p41: `Signature biométrique du règlement`,
    p42: `Scanner de pièce d'identité - passeport`,
    p43: `Stockage cloud illimité`,
    p44: `Boutique de vente croisée`,
    p45: `Envoi automatique des rapports aux autorités`,
    p46: `Synchronisation des réservations PSM`,
    p47: `Mettre à jour l'abonnement`,
    p48: `Continuer`,
    p49: `par`,

    p50: `Sélectionnez des services supplémentaires pour votre forfait`,
    p51: `Recommandé`,
    p52: `WhatsApp`,
    p53: `Nous invitons vos clients à effectuer leur check-in via WhatsApp, programmé avant leur arrivée dans votre hébergement.`,
    p54: `appartement`,
    p55: `villa`,
    p56: `place`,
    p57: `chambre`,
    p58: `Différence dans l'utilisation de WhatsApp`,
    p59: `Utiliser notre WhatsApp`,
    p60: `Lorsque vous utilisez notre service WhatsApp, le nom de l'expéditeur des messages envoyés à vos clients sera WACheckin. Nous gérons les messages pour garantir une communication efficace avec vos clients.`,
    p61: `Si vous utilisez notre service avec votre propre numéro WhatsApp, le nom de l'expéditeur sera votre nom WhatsApp, et vous pourrez avoir votre badge de vérification. Le coût d'envoi dépendra de votre consommation WhatsApp Business avec Meta.`,
    p62: `Utiliser votre WhatsApp Business`,
    p63: `Évaluations`,
    p64: `Saisissez cette opportunité pour améliorer l'expérience de vos clients et obtenir davantage d'avis positifs !`,
    p65: `Avantages`,
    p66: `Au moment du check-out, nous enverrons à vos clients un questionnaire d'évaluation via WhatsApp, améliorant considérablement la réputation en ligne de votre établissement. Notre service est conçu pour augmenter vos avis positifs.`,
    p67: `Accès à distance`,
    p68: `Nous envoyons à vos clients une clé virtuelle pour un accès autonome à la propriété.`,
    p69: `Avantages`,
    p70: `Vos clients recevront les clés d'accès à la chambre de manière sécurisée et pratique une fois leur check-in terminé, ce qui leur offre une expérience sans souci et améliore l'efficacité de la gestion des accès.`,
    p71: `Vérification d'identité`,
    p72: `Nous vérifions l'identité de vos clients grâce à notre logiciel de comparaison biométrique.`,
    p73: `Avantages`,
    p74: `Nous vérifions l'identité de vos clients grâce à notre logiciel de comparaison biométrique, en garantissant que leurs documents correspondent à la personne accédant à votre hébergement.`,
    p75: `Abonnez-vous maintenant`,
    p76: `Stockage cloud illimité`,
    p77: `Personnalisé`,
    p78: `Demandez à notre équipe commerciale`,
    p79: `WhatsApp`,
    p80: `Vérification d'identité`,
    p81: `Avis (évaluations du check-in)`,
    p82: `Connexion à l'API pour serrures connectées`,
    p83: `Débit de carte (pour cautions, services, etc.)`,
    p84: `Contacter le service commercial`,
    p85: ``,
    p86: ``,
    p87: ``,
    p88: ``,
    p89: ``,




};